<div class="kpi-row">
  <div class="kpi-card kpi-card--drilled">
    <div class="kpi-label">Total Drilled Length</div>
    <div class="kpi-value">
      {{ totalDrilled() | number:'1.0-0' }}<span class="kpi-unit"> m</span>
    </div>
    <mat-progress-bar
      mode="determinate"
      [value]="progressPercent()"
      [class.complete]="isComplete()"
      class="drill-progress">
    </mat-progress-bar>
    <div class="progress-label">
      {{ totalDrilled() | number:'1.0-0' }} m / {{ targetMeters() | number:'1.0-0' }} m target
    </div>
  </div>

  <div class="kpi-card">
    <div class="kpi-label">Engine Operation Hours</div>
    <div class="kpi-value">
      {{ totalEngineHours() | number:'1.1-1' }}<span class="kpi-unit"> h</span>
    </div>
  </div>

  <div class="kpi-card">
    <div class="kpi-label">Drilling Rate</div>
    <div class="kpi-value">
      {{ drillingRate() | number:'1.1-1' }}<span class="kpi-unit"> m/h</span>
    </div>
  </div>
</div>
